import { Vue, Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import { genUniqueId, sleep } from "../utils"
import { sysUrl } from '@/globals'

declare const tinymce: any

function _indexable<T>(a: T): T & {[k: string]: any} {
  return a
}

@Component({
  name: 'FormEditor'
})
export default class FormEditor extends Vue {
  @Prop() value: string;

  private _editor: any

  uid: string = '_' + genUniqueId()

  @Watch('value')
  async valuePropChanged(newValue) {
    if (this._editor) {
      if (newValue !== this._editor.getContent()) {
        this._editor.setContent(newValue)
      }
    }
  }

  updateValue(value) {
    this.$emit('input', value)
  }

  editorOptions =  _indexable({
    language_url: './tinymce/langs/zh_CN.js',
    height: 300,
    plugins: [
      'advlist autolink lists link image charmap print preview hr anchor',
      'searchreplace wordcount visualblocks visualchars code fullscreen',
      'media table contextmenu directionality',
      'emoticons paste textcolor colorpicker textpattern imagetools'
    ],
    toolbar: 'undo redo | styleselect fontsizeselect | bold italic | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
    fontsize_formats: "12px 14px 16px 18px 20px 22px 24px 26px 28px",
    image_advtab: true,
    relative_urls: false,
    images_upload_handler: async (blobInfo, success, failure) => {
      let blob = blobInfo.blob()
      let req = new Request(`${sysUrl}/upd/?name=${blob.name}&type=${blob.type}`, {
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        method: 'POST',
        credentials: 'include',
        body: blob,
      })
      let resp = await fetch(req)
      if (!resp.ok) {
        failure(`${resp.status} (${resp.statusText})`)
      }
      let ret = await resp.json();
      if (ret.error) {
        failure(`${ret.error.code} (${ret.error.message})`)
      }
      else {
        success(ret.url)
      }
    },
  })

  mounted() {
    var elText = this.$el.querySelector('textarea')
    let settings = Object.assign({}, this.editorOptions, {
      selector: '#' + this.uid,
      init_instance_callback: editor => {
        this._editor = editor
        editor.on('change', e=>{
          let text = editor.getContent()
          if (text !== this.value) {
            this.updateValue(text)
          }
        })
        editor.on('focus', e => {
          let el = editor.getContainer() as HTMLElement
          el.classList.add('focused')
        })
        editor.on('blur', e => {
          let el = editor.getContainer() as HTMLElement
          el.classList.remove('focused')
        })
      }
    })
    tinymce.init(settings)
  }

  async beforeDestroy() {
    if (this._editor) {
      try {
        if (this._editor.destroy)
          this._editor.destroy()
      }
      catch (e) {
        console.error(e)
      }
    }
    else {
      let self = this
      let $holder = $('<div/>')
        .css('display', 'none')
        .append(this.$el)
        .appendTo('body')
      while (true) {
        await sleep(300)
        if (self._editor) {
          await sleep(100)
          self._editor.destroy()
          $holder.empty().remove()
          break
        }
      }
    }
  }
}
